<template>
  <span class="open-support-widget" onclick="window.fcWidget.open();">contact support</span>
  <!-- <span class="open-support-widget" onclick="window.Freshbots.showWidget('open');">contact support</span> -->
</template>

<script>
export default {

}
</script>

<style scoped>
.open-support-widget{
    cursor: pointer;
    color: #188bf6;
    font-weight: 600;
}
</style>
